export default __webpack_public_path__ + "static/media/amex.3b80bbda.svg";